import React from 'react';
import PropTypes from 'prop-types';

import WithAnalytics from '@component/with-analytics';

// Analytics event listeners
import { methods as audioMethodListeners } from '@app/analytics/audio-player';

import AudioPlayer from './audio-player';

// Extend some components with Analytics
const AudioPlayerWithAnalytics = WithAnalytics({}, {}, audioMethodListeners)(
  AudioPlayer
);

const AudioWrapper = ({ file }) => {
  const metadata = {
    song: file.name,
  };

  return (
    <div className="preview__item preview__item--audio">
      <div className="preview__audio">
        <div className="preview__audio-player">
          <AudioPlayerWithAnalytics file={file} metadata={metadata} />
        </div>
      </div>
    </div>
  );
};

AudioWrapper.propTypes = {
  file: PropTypes.object,
  className: PropTypes.string,
};

export default AudioWrapper;
